var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0664 36.1333L37.4581 30.0417C36.5748 27.975 34.9498 27.8917 33.8581 29.8583L32.2831 32.7C31.4831 34.1417 29.9914 34.2667 28.9581 32.975L28.7748 32.7417C27.6998 31.3917 26.1831 31.5583 25.4081 33.1L23.9748 35.975C22.9664 37.975 24.4248 40.3333 26.6581 40.3333H37.2914C39.4581 40.3333 40.9164 38.125 40.0664 36.1333Z",
    stroke: "#FF8964",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8081 28.6667C29.1888 28.6667 30.3081 27.5474 30.3081 26.1667C30.3081 24.786 29.1888 23.6667 27.8081 23.6667C26.4274 23.6667 25.3081 24.786 25.3081 26.1667C25.3081 27.5474 26.4274 28.6667 27.8081 28.6667Z",
    stroke: "#FF8964",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbPlaceholder);
export default __webpack_public_path__ + "static/media/thumb-placeholder.da287149d8303a40b1987052d9671fa9.svg";
export { ForwardRef as ReactComponent };